const $inject = ['$scope','$routeParams', 'dataService', 'settingsService'];

const lbaMultiSelectCtrl = function ($scope, $routeParams, dataService, settingsService) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);

  vm.data = _.get(dataService.data.activeItem, dataLookUp);

  vm.items = settingsService.options[vm.settings.optionsAt];

  $scope.$watchCollection('vm.data', (newData, oldData) => {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, dataLookUp, newData)
    }
  });

};

lbaMultiSelectCtrl.$inject = $inject;

export default lbaMultiSelectCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaMultiSelect/lbaMultiSelectCtrl.js